import React, { useState, useEffect } from "react";
import "./Hero.css";

// Import all banner images
import banner1 from "../assets/banner/banner1.jpg";
import banner3 from "../assets/banner/banner3.jpg";
import banner4 from "../assets/banner/banner4.jpg";

const banners = [banner1, banner3, banner4];

export default function Hero() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero" id="home">
      {/* Slides */}
      {banners.map((banner, index) => (
        <img
          key={index}
          src={banner}
          alt={`Banner ${index + 1}`}
          className={`hero-slide ${index === current ? "active" : ""}`}
        />
      ))}

      <div className="hero-content">
        <h1> ONE DAY IT WILL MAKE SENSE.</h1>
        <p>Connecting, mentoring, and transforming the lives of young people.</p>
        <div className="hero-actions">
          <a href="#contact" className="btn btn-primary">Donate Now</a> 
        </div>
      </div>

      {/* Navigation Dots */}
      <div className="hero-dots">
        {banners.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === current ? "active" : ""}`}
            onClick={() => setCurrent(index)}
          ></span>
        ))}
      </div>
    </section>
  );
}
